import styled from 'styled-components';
import { NavLink, Link } from 'react-router-dom';

const activeClassName = 'nav-item-active';

export const Wrapper = styled.div`
    height: calc(100vh - 56px);
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.gray};
    padding: ${({ theme }) => theme.spacing * 8}px;
    display: flex;
    flex-direction: column;
    width: 100%;
    box-sizing: border-box;
`;

export const UserWrapperAdmin = styled.div`
    display: flex;
    align-items: center;
    padding-bottom: ${({ theme }) => theme.spacing * 8}px;
    > p {
        font-weight: bold;
        margin-left: ${({ theme }) => theme.spacing * 3}px;
    }
`;

export const UserWrapper = styled.div`
    display: grid;
    grid-template-columns: 70px 1fr;
    grid-column-gap: ${({ theme }) => theme.spacing * 4}px;
    align-items: center;
    font-weight: bold;
    padding-bottom: ${({ theme }) => theme.spacing * 8}px;
    > div {
        > h1 {
            font-size: 14px;
            margin: 0;
        }
        .label {
            font-size: 12px;
            opacity: .87;
            color: ${({ theme }) => theme.colors.gray};
        }
        > h3 {
            color: ${({ theme }) => theme.colors.primary};
            font-weight: bold;
            margin: 0;
            display: inline-block;
            margin-left: ${({ theme }) => theme.spacing * 2}px;
        }
    }
`;

export const StyledLink = styled(NavLink).attrs({ activeClassName })`
    display: block;
    margin: ${({ theme }) => theme.spacing * 8}px 0;
    color: ${({ theme }) => theme.colors.gray};
    font-weight: bold;
    text-decoration: none;
    text-transform: uppercase;
    &.${activeClassName} {
        color: ${({ theme }) => theme.colors.primary};
    }
`;

export const CreateButton = styled(Link)`
    height: 44px;
    display: block;
    margin: ${({ theme }) => theme.spacing * 4}px auto;
    padding: 0 ${({ theme }) => theme.spacing * 6}px;
    color: ${({ theme }) => theme.colors.white};
    background-color: #062B54;
    border-radius: 6px;
    font-size: 12px;
    font-weight: bold;
    line-height: 44px;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    box-sizing: border-box;
    width: 100%;
`;

export const ButtonFree = styled.button`
    display: block;
    height: 44px;
    margin: ${({ theme }) => theme.spacing * 4}px auto;
    padding: 0 ${({ theme }) => theme.spacing * 6}px;
    color: ${({ theme }) => theme.colors.white};
    background-color: #062B54;
    border-radius: 6px;
    font-size: 12px;
    font-weight: bold;
    text-decoration: none;
    text-transform: uppercase;
    outline: none;
    border: none;
    width: 100%;
`;

export const Button = styled(CreateButton)`
    margin-bottom: ${({ theme }) => theme.spacing * 4}px;
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
`;

export const SeparatorWrapper = styled.div`
    position: relative;
    z-index: 1;
    >span {
        position: absolute;
        left: 50%;
        top: 50%;
        z-index: 2;
        transform: translate(-50%, -50%);
        background-color: white;
        padding: 0 ${({ theme }) => theme.spacing * 2}px 
            ${({ theme }) => theme.spacing}px;
    }
`;

export const Title = styled.h3`
    text-align: center;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.gray};
`;
